module.exports = __webpack_public_path__ + "static/efreeti-b2a9ef3914ab0da2c82daaaae24a3bc8.jpg";